"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9553],{

/***/ 71125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ BreadcrumbItemLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);



const BreadcrumbItemLink = (param)=>{
    let { href , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        className: "breadcrumbs__item-link",
        ...props,
        children: children
    });
};
BreadcrumbItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const BreadcrumbItem = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "breadcrumbs__item",
        ...props
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);


/***/ }),

/***/ 78086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Breadcrumbs.js




const Breadcrumbs = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("breadcrumbs", className),
        children: children
    });
};
Breadcrumbs.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js



/***/ }),

/***/ 43360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const GuidePageTemplateMain = (param)=>{
    let { sidebar =true , children , ...props } = param;
    const responsiveProps = sidebar ? {
        auto: true
    } : {
        lg: 9
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        ...responsiveProps,
        ...props,
        children: children
    });
};
GuidePageTemplateMain.propTypes = {
    sidebar: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (GuidePageTemplateMain);


/***/ }),

/***/ 69738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NI": function() { return /* binding */ GuidePageTemplateNavItemLink; },
/* harmony export */   "hS": function() { return /* binding */ GuidePageTemplateNavItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);




const GuidePageTemplateNavItem = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "guide-page-template__nav-item",
        children: children
    });
};
GuidePageTemplateNavItem.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
const GuidePageTemplateNavItemLink = (param)=>{
    let { href , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        className: "guide-page-template__nav-item-link",
        ...props,
        children: children
    });
};
GuidePageTemplateNavItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const GuidePageTemplateNav = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "guide-page-template__nav",
        children: children
    });
};
GuidePageTemplateNav.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["ZP"] = (GuidePageTemplateNav);


/***/ }),

/***/ 51921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const GuidePageTemplateSidebar = (param)=>{
    let { md =4 , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: md,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "guide-page-template__sidebar",
            children: children
        })
    });
};
GuidePageTemplateSidebar.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired,
    md: prop_types__WEBPACK_IMPORTED_MODULE_3__.number
};
/* harmony default export */ __webpack_exports__["Z"] = (GuidePageTemplateSidebar);


/***/ }),

/***/ 41635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GuidePageTemplate_GuidePageTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/GuidePageTemplate.js






const GuidePageTemplate = (param)=>{
    let { type ="guide" , wrapperClassName ="" , sidebar =true , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("guide-page-template", "guide-page-template-type-".concat(type), wrapperClassName),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                center: !sidebar,
                children: children
            })
        })
    });
};
GuidePageTemplate.propTypes = {
    type: (0,prop_types.oneOf)([
        "guide",
        "tutorial"
    ]),
    wrapperClassName: prop_types.string,
    sidebar: prop_types.bool,
    children: prop_types.node.isRequired
};
/* harmony default export */ var GuidePageTemplate_GuidePageTemplate = (GuidePageTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/index.js



/***/ }),

/***/ 88554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InputGroup_InputGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/InputGroup/InputGroup.js





const InputGroupPrepend = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "input-group-prepend",
        children: children
    });
};
InputGroupPrepend.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroupAppend = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "input-group-append",
        children: children
    });
};
InputGroupAppend.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroupField = (param)=>{
    let { children  } = param;
    return children;
};
InputGroupField.propTypes = {
    children: prop_types.node.isRequired
};
const InputGroup = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("input-group", className),
        children: children
    });
};
InputGroup.propTypes = {
    children: prop_types.node.isRequired,
    className: prop_types.string
};
const InputGroupButton = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,jsx_runtime.jsx)(Button/* default */.Z, {
        styleType: "input-group",
        size: "s",
        ...props
    });
};
InputGroupButton.propTypes = {
    ...Button/* default.propTypes */.Z.propTypes
};
InputGroup.Prepend = InputGroupPrepend;
InputGroup.Append = InputGroupAppend;
InputGroup.Field = InputGroupField;
InputGroup.Button = InputGroupButton;
/* harmony default export */ var InputGroup_InputGroup = (InputGroup);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/InputGroup/index.js



/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    utility: {
                        position: {
                            position: "relative",
                            zIndex: 1
                        }
                    },
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 5370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ BackToTopButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61672);




const BackToTopButton = ()=>{
    const [showButton, setShowButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [prevOffset, setPrevOffset] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const toggleScrollDirection = ()=>{
        const { scrollY  } = window;
        const screenHeight = window.screen.height * 2;
        if (scrollY > prevOffset || scrollY < screenHeight) {
            setShowButton(false);
        } else if (scrollY < prevOffset && scrollY > screenHeight) {
            setShowButton(true);
        }
        setPrevOffset(scrollY);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.addEventListener("scroll", toggleScrollDirection);
        return ()=>{
            window.removeEventListener("scroll", toggleScrollDirection);
        };
    });
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "back-to-top-button",
            onClick: scrollToTop,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: "chevron-up",
                    className: "back-to-top-button--icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "back-to-top-button--text",
                    children: "TOP"
                })
            ]
        })
    });
};


/***/ }),

/***/ 6930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67478);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);






const SectionSearchBar = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "section-search-bar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX, {
                    sm: 12,
                    md: 11,
                    lg: 8,
                    children: children
                })
            })
        })
    });
};
SectionSearchBar.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h2",
        sx: {
            fontSize: "xl",
            textAlign: "center"
        },
        spacing: {
            mt: 0,
            mb: 2
        },
        children: children
    });
};
Title.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
SectionSearchBar.Title = Title;
/* harmony default export */ __webpack_exports__["Z"] = (SectionSearchBar);


/***/ }),

/***/ 61603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ scrollToHeading; }
/* harmony export */ });
const scrollToHeading = (e)=>{
    e.preventDefault();
    const siblingsFn = (elem)=>{
        const siblings = [];
        let sibling = elem;
        while(sibling.previousSibling){
            sibling = sibling.previousSibling;
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
        }
        sibling = elem;
        while(sibling.nextSibling){
            sibling = sibling.nextSibling;
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
        }
        return siblings;
    };
    const link = e.target;
    const activeClass = "guide-post-container__nav-item-link--active";
    link.classList.add(activeClass);
    siblingsFn(link.parentNode).forEach((sib)=>{
        if (!sib.getElementsByTagName("a").length) {
            return;
        }
        sib.getElementsByTagName("a")[0].classList.remove(activeClass);
    });
    const id = e.target.hash.replace("#", "");
    const element = document.getElementById(id);
    __webpack_require__.g.window.scrollTo({
        behavior: element ? "smooth" : "auto",
        top: element ? element.offsetTop : 0
    });
};


/***/ }),

/***/ 91364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReleaseNotes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/createClient/index.js
var createClient = __webpack_require__(15959);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/BackToTopButton/index.js
var BackToTopButton = __webpack_require__(5370);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PostElement/index.js + 4 modules
var PostElement = __webpack_require__(22857);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/Guides/index.js
var Guides = __webpack_require__(61603);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(78086);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Item.js
var Item = __webpack_require__(71125);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/index.js + 1 modules
var GuidePageTemplate = __webpack_require__(41635);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Main.js
var Main = __webpack_require__(43360);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Sidebar.js
var Sidebar = __webpack_require__(51921);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Nav.js
var Nav = __webpack_require__(69738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/index.js + 5 modules
var richTextTypes_default = __webpack_require__(34124);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/utils.js + 1 modules
var utils = __webpack_require__(69482);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/ReleaseNotes/Page.js





















const ReleaseNotesPage = (param)=>{
    let { post , pageProps  } = param;
    const [t] = (0,i18/* useLocale */.bU)("updates");
    const { siteDomain  } = pageProps;
    const { title , metaDescription ="" , slug , releaseDate , appVersionNumber , publishStatus , body  } = post;
    const currentPageURL = "".concat(siteDomain, "/updates/").concat(slug);
    const navigation = body ? (0,utils/* sidebarNavigation */.U)(body) : [];
    const metaRobotsContent = publishStatus === "Live" ? "index, follow" : "noindex, follow";
    const wasReleasedMessage = /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementParagraph */.DK, {
        italic: true,
        suppressHydrationWarning: true,
        children: [
            t("PRODUCT_NAME"),
            " ",
            appVersionNumber,
            " ",
            t("UPDATES.WAS_RELEASED_ON"),
            " ",
            t("{{releaseDate, LONGDATE}}", {
                releaseDate
            }),
            "."
        ]
    });
    const totalHeading2 = body.content.reduce((total, current)=>{
        return total + (current.nodeType === "heading-2" ? 1 : 0);
    }, 0);
    const isSidebar = totalHeading2 > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: title,
                description: metaDescription,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: title,
                        description: metaDescription,
                        url: currentPageURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: currentPageURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                        content: metaRobotsContent
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                color: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* BreadcrumbItemLink */.A, {
                                    href: "/",
                                    children: "Home"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    Component: Item/* BreadcrumbItemLink */.A,
                                    href: "/updates",
                                    children: "Updates"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuidePageTemplate/* default */.Z, {
                sidebar: isSidebar,
                children: [
                    navigation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                        children: navigation.map((item)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* GuidePageTemplateNavItem */.hS, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* GuidePageTemplateNavItemLink */.NI, {
                                    href: "#".concat((0,utils/* generateHeadingId */.A)(item)),
                                    onClick: (e)=>(0,Guides/* scrollToHeading */.U)(e),
                                    children: item
                                })
                            }, item);
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main/* default */.Z, {
                        sidebar: isSidebar,
                        children: [
                            publishStatus === "Live" && wasReleasedMessage,
                            body ? (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, richTextTypes_default/* default */.Z) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTopButton/* BackToTopButton */.z, {})
        ]
    });
};
ReleaseNotesPage.propTypes = {
    post: (0,prop_types.shape)({
        title: prop_types.string.isRequired,
        metaDescription: prop_types.string,
        appReleaseNotes: prop_types.object,
        appVersionNumber: prop_types.string,
        body: prop_types.object,
        publishStatus: (0,prop_types.oneOf)([
            "Hidden",
            constants/* PUBLISHED */.lc
        ]),
        releaseDate: prop_types.string,
        slug: prop_types.string,
        teaser: prop_types.object,
        macInstallerUrl: prop_types.string,
        windowsInstallerUrl: prop_types.string
    }),
    pageProps: (0,prop_types.shape)({
        resources: prop_types.any,
        siteDomain: prop_types.string
    })
};
/* harmony default export */ var ReleaseNotes_Page = (ReleaseNotesPage);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/locales/index.js
var locales = __webpack_require__(5235);
var locales_default = /*#__PURE__*/__webpack_require__.n(locales);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/contentfulSanitizer.js
var contentfulSanitizer = __webpack_require__(50420);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/ReleaseNotes/index.js











const ContentfulReleaseNotesFactory = (param)=>{
    let { Layout , Page , contentfulProps , pageProps  } = param;
    const ContentfulReleaseNotesPage = (param)=>{
        let { post  } = param;
        const { brandCode , resources =null  } = pageProps;
        const PageComponent = pageProps.PageComponent || ReleaseNotes_Page;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18/* LocaleProvider */.Iw, {
                resources: resources || (locales_default())[brandCode],
                children: Page ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    post: post,
                    pageProps: pageProps
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PageComponent, {
                    post: post,
                    pageProps: pageProps
                })
            })
        });
    };
    ContentfulReleaseNotesPage.getInitialProps = async (props)=>{
        const { slug  } = props.query;
        const client = (0,createClient/* default */.Z)(contentfulProps);
        const items = await client.getEntries({
            content_type: "pageReleaseNotes",
            "fields.slug": slug
        });
        if (items.total === 0) {
            return {
                post: null
            };
        }
        return {
            post: (0,contentfulSanitizer/* sanitize */.N)(items.items[0].fields)
        };
    };
    ContentfulReleaseNotesPage.propTypes = Page ? {
        ...Page.propTypes
    } : {
        ...ReleaseNotes_Page.propTypes
    };
    ContentfulReleaseNotesPage.postConditions = [
        [
            (param)=>{
                let { post  } = param;
                return post;
            },
            (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
        ]
    ];
    return (0,pipe/* default */.Z)(ContentfulReleaseNotesPage, WithConditions/* default */.ZP);
};
/* harmony default export */ var ReleaseNotes = (ContentfulReleaseNotesFactory);


/***/ }),

/***/ 73972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Html = (param)=>/*#__PURE__*/ {
    let { Tag ="div" , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        dangerouslySetInnerHTML: {
            __html: children
        },
        ...props
    });
};
Html.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_2__.element
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (Html);


/***/ })

}]);